module.exports = __webpack_public_path__ + "static/media/02_hero_tablet.4daf61c3.jpg";